import React from 'react';
import { useAuth } from '@/contexts/AuthContext';

const ENTITY_ROUTES = {
  item: (id) => `/inventory/items/${id}`,
  route: (id) => `/production/routes/${id}`,
  workOrder: (id) => `/production/work-orders`,
  challan: (id) => `/production/subcontract`,
  supplier: (id) => `/suppliers/${id}`,
  po: (id) => `/contracts/purchase-orders/${id}`,
  customer: (id) => `/contracts/customers/${id}`,
  tool: (id) => `/quality/calibration/${id}`,
};

export function EntityLink({ type, id, children, className = '' }) {
  const { user } = useAuth();
  if (!id || !type || !ENTITY_ROUTES[type]) {
    return <span className={className}>{children}</span>;
  }
  // Work Orders live under Admin Tools now — non-admins get the Daily Plan instead.
  if (type === 'workOrder' && user?.role !== 'admin') {
    return <span className={className}>{children}</span>;
  }

  const href = ENTITY_ROUTES[type](id);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className={`text-blue-700 hover:text-blue-900 hover:underline cursor-pointer ${className}`}
      data-testid={`entity-link-${type}-${id}`}
    >
      {children}
    </a>
  );
}
